import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCloudWeather: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCloudWeather"><Path d="M9 4C4.58172 4 1 7.58172 1 12C1 16.4183 4.58172 20 9 20H17C20.3137 20 23 17.3137 23 14C23 10.6863 20.3137 8 17 8C16.6524 8 16.3112 8.02966 15.9789 8.0867C14.6092 5.6491 11.9981 4 9 4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCloudWeather;
